import { Fragment, useMemo } from "react";

import { Element } from "@craftjs/core";

import { prop, define } from "@/components/builder/utils";
import { DnDBypassProvider } from "@/components/builder/utils/bypass-context";

import { FormRadioMultiContainerBlock, FormRadioMultiInputBlock, FormRadioMultiLabelBlock } from "../../..";
import BasePreview from "../../../base";
import { useFormFieldContext } from "../context";

const TITLE_OPTIONS = [
  {
    label: 'Mr.',
    value: 'mr',
  },
  {
    label: 'Ms.',
    value: 'ms',
  },
  {
    label: 'Mrs.',
    value: 'mrs',
  },
]

const GENDER_OPTIONS = [
  {
    label: 'Male',
    value: 'male',
  },
  {
    label: 'Female',
    value: 'female',
  },
]

function FormRadioMultiPreview({ ...props }) {
  const { field: { field_options, field } } = useFormFieldContext()

  const options = useMemo(() => {
    switch (field) {
      case 'gender':
        return GENDER_OPTIONS
      case 'title':
        return TITLE_OPTIONS
      default:
        return field_options || []
    }
  }, [field, field_options])

  return <BasePreview {...props}>
    <div>
      {options.map((option, index) => <div key={index}>
        <DnDBypassProvider data={option}>
          <Element key={index} is={FormRadioMultiContainerBlock} id={`radio-multi-container-${index}`}>
            <Element key={index} is={FormRadioMultiInputBlock} id={`radio-multi-input-${index}`} />
            <Element key={index} is={FormRadioMultiLabelBlock} id={`radio-multi-label-${index}`} />
          </Element>
        </DnDBypassProvider>

      </div>)}
    </div>
  </BasePreview>
}

export default define('form-radio-multi', FormRadioMultiPreview, Fragment)
  .shared(prop.share('FormRadioMulti', 'form-radio-multi'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .build()

